import { FC } from 'react'

const FinnishFlagSmall: FC = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="0.5"
      width="15"
      height="15"
      rx="7.5"
      fill="white"
      stroke="#033883"
      strokeWidth="0.5"
    />
    <path
      d="M5.53906 1.47969C5.53906 1.03786 5.89723 0.679688 6.33906 0.679688H9.53906V15.2656H6.33906C5.89723 15.2656 5.53906 14.9075 5.53906 14.4656V1.47969Z"
      fill="#033883"
    />
    <rect
      x="15.75"
      y="5.96875"
      width="4"
      height="14.5078"
      transform="rotate(90 15.75 5.96875)"
      fill="#033883"
    />
  </svg>
)

export default FinnishFlagSmall
